module.exports = __webpack_public_path__ + "img/credit.c3e926d7.svg";